import { baseProductFilterSchema } from "@redotech/redo-model/product-filters/product-filters-db-parser";
import * as z from "zod";

export const createProductFilter = {
  name: "createProductFilter" as const,
  input: baseProductFilterSchema,
  output: z.object({ productFilterId: z.string() }),
};
